import api from '@/api/api.js'

// PORT-001 : liste des patients libérés et constatation de sortie (be_clinique).
// En-tête X-Portail-Access : portail:read pour la liste, portail:passage pour la constatation.
export default {
    getPatientsLiberes(data, access_token) {
        return api.clinique().post('/portail/liberes', { auth_id: data.auth_id },
            { headers: { 'X-Portail-Access': access_token }, med_access_scoped: true, timeout: 20000 }).then(response => response.data)
    },
    constaterSortie(data, access_token) {
        return api.clinique().post('/portail/sorties/constater',
            { auth_id: data.auth_id, patient_id: data.patient_id, requete_id: data.requete_id },
            { headers: { 'X-Portail-Access': access_token }, med_access_scoped: true, timeout: 20000 }).then(response => response.data)
    }
}
